import { COUNTRIES } from '@hotjar/country-lib';
import type { LargeListFilterValue } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getLabels as largeListLabelFormatterGetLabels } from './GenericLabelFormatter/LargeListLabelFormatter';

export function getLabels(currentValue?: LargeListFilterValue<string>): LabelProps {
  return largeListLabelFormatterGetLabels(currentValue, FilterKindEnum.Country, {
    optionList: COUNTRIES,
  });
}
